import { createSelector, Selector } from 'reselect'

import { ContractState } from './contract.reducer'

import { Price } from '~/basket/model/common/price.model'
import { filterFalsyValues } from '~/core/helpers/helpers'
import { RootState } from '~/core/store/root.reducer'
import { selectCustomerValues } from '~/customer/store/customer.selectors'
import { selectAllLinesIds, selectLine, selectLinePhoneNumber } from '~/line/store/line.selectors'
import { addTaxToPriceRounded } from '~/prices/prices.helpers'
import { selectTaxValue } from '~/prices/store/prices.selectors'
import { selectSelectedTariff } from '~/tariff/store/tariff.selectors'

type GetContract = Selector<RootState, ContractState>

const getContract: GetContract = (state: RootState) => state.contract

export const selectPreContract = createSelector(getContract, (contract) => contract.preContract)

export const selectCustomerPreContractBody = createSelector(
  selectCustomerValues,
  ({ name, firstName, lastName, contactPhone, language }) => {
    return {
      name,
      firstName,
      lastName,
      contactPhone,
      language: {
        value: language,
      },
    }
  },
)

export const selectSignUpFromLine = createSelector(
  selectLine,
  selectLinePhoneNumber,
  (line, phoneNumber) => {
    return {
      signUpType: line?.values.signUp.signUpType,
      lineNumber: phoneNumber,
    }
  },
)

export const selectTariffInfoFromLine = createSelector(
  selectSelectedTariff,
  selectTaxValue,
  (tariff, taxValue) => {
    const tariffDiscount = tariff?.discount || []
    return filterFalsyValues({
      name: tariff?.name,
      mobileData: { amount: tariff?.mobileData?.amount },
      call: tariff?.call.map((tariff) => {
        const callType = tariff?.callType && tariff?.callType !== null ? tariff.callType : undefined
        return {
          callType,
          amount: tariff?.amount,
        }
      }),
      discount: tariffDiscount.map(({ productCategory, ...discount }) => {
        const termDiscount = discount?.term || []
        return {
          ...discount,
          term: termDiscount.map(({ productCategory, ...term }) => {
            return {
              ...term,
              price: [...addTaxToPriceRounded(term?.price as Price[], taxValue)],
            }
          }),
        }
      }),
      price: [...addTaxToPriceRounded(tariff?.price as Price[], taxValue)],
    })
  },
)

export const selectBasketPreContractBody = createSelector(
  (state) => state,
  selectAllLinesIds,
  (state, allLinesIds) => {
    return allLinesIds.map((elem) => {
      return {
        signUp: selectSignUpFromLine(state, elem),
        tariff: selectTariffInfoFromLine(state, elem),
      }
    })
  },
)

export const selectPreContractBody = createSelector(
  selectCustomerPreContractBody,
  selectBasketPreContractBody,

  (customer, basket) => {
    return {
      customer,
      basket,
    }
  },
)
